import { createSelector } from '@reduxjs/toolkit'

import { selectBusinessPrioritiesState } from './selectBusinessPrioritiesState'

export const selectBusinessPriorities = createSelector(
  [selectBusinessPrioritiesState],
  (state) => state.records
)
